<template>
  <data-table
    :table-header="tugPerformanceHeaders"
    :table-data="tugPerformanceData"
    body-height="100vh"
  />
</template>

<script>
import DataTable from '@/components/dataTable'

export default {
  components: {
    DataTable
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data: {
      handler(val) {
        this.tugPerformanceData = val
      }
    }
  },
  data() {
    return {
      tugPerformanceHeaders: [
        { key: 'month_year', label: 'Month & Years' },
        { key: 'trip_number', label: 'Trip No' },
        { key: 'route', label: 'Route' },
        { key: 'tug', label: 'Tug' },
        { key: 'breakdown', label: 'Breakdown' },
        { key: 'waiting_certificate', label: 'Waiting Certificate' },
        { key: 'accident', label: 'Accident' },
        { key: 'others', label: 'Others' }
      ],
      tugPerformanceData: []
    }
  }
}
</script>

<style scoped>

</style>
